import React from 'react'

const BottomLine = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={229}
      height={20}
      viewBox="0 0 229 20"
      fill="none"
      {...props}
    >
      <path
        d="M2.00005 17.1739C115.881 -7.45835 221.971 5.39439 226.464 5.04"
        stroke="url(#paint0_linear_20387_34848)"
        strokeWidth={4}
        strokeLinecap="round"
      />
      <defs>
        <linearGradient
          id="paint0_linear_20387_34848"
          x1="113.563"
          y1="2.61818"
          x2="114.451"
          y2="13.875"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F9742C" />
          <stop offset={1} stopColor="#F20486" />
        </linearGradient>
      </defs>
    </svg>

  )
}

export default BottomLine